import { useSelector } from 'react-redux';
import { AppendixConfigState } from '../../redux/localReports/localReports.proptype';
import { selectAppendixConfigState } from '../../selectors';

export const useAppendixConfigState = (): AppendixConfigState => {
  const selectedAppendixConfigState = useSelector(selectAppendixConfigState);

  return selectedAppendixConfigState;
};
